import {
  useBreakpointValue,
  Container,
  Flex,
  Stack,
  Box,
  Heading,
  Spinner,
  Button,
} from '@chakra-ui/react'
import { Logo } from '@components/Elements/Logo'
import { PageLoader } from '@components/Loader/PageLoader'
import { SignInForm } from '@features/auth/components/SignInForm'
import { useUser } from '@lib/firebase/provider'
import { core, firebaseClientInitConfig } from '@lib/firebase/config'
import {
  createFileRoute,
  useSearch,
  useNavigate,
  Link,
} from '@tanstack/react-router'
import { Route as ForgotPassword } from '@routes/forgotPassword'
import { z } from 'zod'

const TENANT = firebaseClientInitConfig.tenantIds.endUser

const SignInRoute = () => {
  const { loading } = useUser()
  const breakPointValue = useBreakpointValue({ base: 'xs', md: 'sm' })

  const search = useSearch({ from: '/signin' })
  const navigate = useNavigate({ from: '/signin' })

  const redirectUrl = search?.redirect ?? core.appPageUrl

  if (loading) {
    return <PageLoader />
  }

  return (
    <Container maxW="md" py={{ base: '12', md: '24' }}>
      {loading ? (
        <Flex
          w={'100%'}
          justify="center"
          h={'100%'}
          align={'center'}
          direction={'column'}
        >
          <Spinner />
        </Flex>
      ) : (
        <Stack spacing="8">
          <Stack spacing="6">
            <Box px="120" py="50" marginTop="30px">
              <Logo />
            </Box>
            <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
              <Heading size={breakPointValue}>Log in to your account</Heading>
              {/* <HStack spacing="1" justify="center"> */}
              {/*  <Text color="muted">Don't have an account?</Text> */}
              {/*  <Link href="/register"> */}
              {/*    <Button variant="link" colorScheme="blue"> */}
              {/*      Sign up */}
              {/*    </Button> */}
              {/*  </Link> */}
              {/* </HStack> */}
            </Stack>
          </Stack>
          <Stack spacing="6">
            <SignInForm
              navigate={navigate}
              tenant={TENANT}
              redirectUrl={redirectUrl}
              forgotPasswordElement={
                <Link to={ForgotPassword.to}>
                  <Button variant="link" colorScheme="blue" size="sm">
                    Forgot password
                  </Button>
                </Link>
              }
            />
          </Stack>
        </Stack>
      )}
    </Container>
  )
}

const routerSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/signin')({
  component: SignInRoute,
  validateSearch: routerSchema,
})
